module.exports = __webpack_public_path__ + "static/media/кардио - Кросс-тренажер.7e64cf39.jpg";